import React, { useMemo } from "react";
import { MessageOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import DocsForm from "./DocForm";
import InfoCard from "src/components/Profile/infoCard";
import FinancialInfoCard from "/src/components/Profile/financialInfoCard";
import TelegramButton from "./TelegramButton";
import useUser from "../../hooks/useUser";
import useOrg from "../../hooks/apis/useOrg";
import { isActiveCustomer } from "../../hooks/useIsActiveCustomer";
import Loading from "../../components/loading";
import Error from "../../components/error";
import Card from "../../components/Card";
import ChannelsCard from "../../components/Profile/channelsCard";
import RelatedChannelsCard from "../../components/Profile/relatedChannelsCard";
import ContractsCard from "../../components/Profile/contractsCard";
import { IS_WHITE_LABEL } from "../../constants";

function Settings() {
  const { data, isLoading: loading, error } = useUser();
  const { data: org } = useOrg();
  const isWhiteLabel = org?.config?.whiteLabel ?? IS_WHITE_LABEL;

  const showForm = useMemo(
    () =>
      data?.gbpCredit > 0 ||
      data?.channels?.some((ch) =>
        [
          "FINAL_CHECK",
          "ACCESS_OR_SCREEN",
          "DOCS_NEEDED",
          "PREPARING_CONTRACT",
          "SIGNING_AND_MANAGER_ACCESS",
          "ADSENSE_SETUP",
          "ACTIVE_CUSTOMER",
        ].includes(ch.state)
      ),
    [data]
  );
  const formDisabled = useMemo(
    () => isActiveCustomer(data?.channels),
    [data]
  );

  if (error)
    return (
      <Error
        size="fill"
        iconClassName="text-[red]"
        textClassName="text-[red] mt-2  text-2xl"
        text="خطایی رخ داده است"
      />
    );
  if (loading) {
    return <Loading size="fill" text="در حال بارگذاری..." />;
  }

  return (
    <div direction="vertical" size={50}>
      <div
        className="w-full"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 500px), 1fr))",
          gap: "32px",
          gridAutoFlow: "dense",
        }}
      >
        {!isWhiteLabel && (
          <Flex vertical gap={16}>
            <ChannelsCard />
            <RelatedChannelsCard />
            <ContractsCard />
            {org?.config?.telegramSupportUsername && (
              <Card
                title="پشتیبانی"
                Icon={MessageOutlined}
                actions={<TelegramButton data={data} />}
              />
            )}
          </Flex>
        )}

        {showForm ? (
          <>
            <InfoCard />
            <FinancialInfoCard />
            {!isWhiteLabel && <DocsForm data={data} disabled={formDisabled} />}
          </>
        ) : null}
        {isWhiteLabel && <ContractsCard />}
      </div>
      {/* {renderForm()} */}
    </div>
  );
}

export default Settings;
